const getters = {
    scaleHouses: state => state.scale_houses,
    scales: state => state.scales,
    scaleMeasurements: state => state.scale_measurements,
    weighingOnScaleTypes: state => state.weighing_on_scale_types,
    weighingOnScaleVehicleConf: state => state.weighing_on_scale_vehicle_conf,
}

export default getters;
